export class LocalizationForm extends HTMLElement {
    constructor() {
        super();

        this.selectors = {
            select: "[js-country-select]",
            input: "[js-country-select-input]",
            submit: "[js-country-select-submit]",
        };
    }

    connectedCallback() {
        this.select = this.querySelector(this.selectors.select);
        this.select.addEventListener("change", this.onItemClick);

        this.input = this.querySelector(this.selectors.input);
    }

    onItemClick = (event) => {
        event.preventDefault();
        this.input.value = event.currentTarget.value;
    };
}
